import React from "react";
import logo from "../../assets/logo.png";
import bannerImg from "../../assets/banner-img.png";
import "../../App.css";
import { ConnectWallet } from "@thirdweb-dev/react";
import { darkTheme, lightTheme } from "@thirdweb-dev/react";

const Banner = () => {
  const customDarkTheme = darkTheme({
    fontFamily: "Inter, sans-serif",
    colors: {
      modalBg: "#000000",
      accentText: "red",
      // ... etc
    },
  });

  return (
    <div>
      <div className="relative img-banner flex justify-between items-start">
        <div className="flex items-start flex-col justify-start gap-[40px] lg:gap-[50px] xl:gap-[60px] pl-[3vw] pt-[5vw]">
          <img src={logo} alt="" className="banner-logo" />
          {/* <img src={banner} alt="" className="w-full" /> */}
          <div className="banner-div mt-4 xl:mt-8">
            <h2 className=" font-extrabold text-white text-[24px] sm:text-[32px] lg:text-[36px] xl:text-[42px] leading-[35px] lg:leading-[40px] xl:leading-[50px] text-center sm:text-left">
              Brú Finance XP Program
            </h2>
            <h5 className=" font-medium text-[#F0F3FF] text-[18px] sm:text-[16px] lg:text-[20px] xl:text-[22px] leading-[20px] lg:leading-[25px] xl:leading-[30px] mt-3 text-center sm:text-left">
              🇮🇳 India's Largest RWA Tokenization Platform
            </h5>
            {/* <button className="mt-4 lg:mt-6 xl:mt-8 bg-[#15F5BA] rounded-[66px] py-[10px] px-[22px] sm:px-[36px] text-[#211951] font-semibold float-center sm:float-left">
              Connect Wallet{" "}
            </button> */}
            <ConnectWallet
              className="mt-8 bg-[#15F5BA] rounded-[66px] py-[10px] px-[22px] sm:px-[36px] text-[#211951] font-semibold float-center sm:float-left"
              style={{
                all: "set !important",
                float: "left",
                backgroundColor: "#15F5BA",
                marginTop: 15,
                color: "black !important",
              }}
              // theme="dark"
            />
          </div>
        </div>{" "}
        <img src={bannerImg} alt="" className="banner-side" />
      </div>
    </div>
  );
};

export default Banner;
